module.exports = __webpack_public_path__ + "static/media/024-car.a363b675.svg";